import { Route } from '@angular/router';
import { SigningCadesComponent } from './signing-cades.component';

export const SigningCadesRoutes: Route[] = [
  {
    path: 'signc/:code',
    component: SigningCadesComponent
  }
];
